import React from 'react';

import { LinkShipmentSearchItemProps } from './LinkShipmentSearchItem.props';
import { StyledStack } from './LinkShipmentSearchItem.styles';
import { COLORS } from '../../../configs/colors';
import { Typography, TypographyVariantProps } from '../../atoms/Typography';

export const LinkShipmentSearchItem: React.FC<LinkShipmentSearchItemProps> = ({
  data
}) => {
  return (
    <StyledStack direction="column">
      <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Subtitle2}>AM-SID-{data.id}</Typography>
      <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>Source: {data.source}</Typography>
      <Typography textColor={COLORS.Black} variant={TypographyVariantProps.Caption}>Destination: {data.destination}</Typography>
    </StyledStack>
  );
};